export const launchHyperVergeWorkflow = async (accessToken, workflowId, transactionId, pan_name, onApproved) => {
  try {
    
    const hyperKycConfig = new window.HyperKycConfig(accessToken, workflowId, transactionId);

    if(workflowId === 'karncy_bankVerification'){
      const customInputs = {
        pan_name
    }
    hyperKycConfig.setInputs(customInputs)
    }
    const handler = (HyperKycResult) => {
      switch (HyperKycResult.status) {
        case "user_cancelled":
          break;
        case "error":
          console.error("Error during workflow");
          onApproved(HyperKycResult); // Pass error back so Kyc.jsx can trigger manual fallback
          break;
        case "auto_approved":
          // When the workflow is auto-approved, call the Node.js API
          onApproved(HyperKycResult); // Pass the result back to the parent component
          break;
        case "auto_declined":
          onApproved(HyperKycResult); // Pass declined status back for handling
          break;
        case "needs_review":
          onApproved(HyperKycResult);
          break;
        default:
      }
    };

    await window.HyperKYCModule.launch(hyperKycConfig, handler);
  } catch (error) {
    console.error("Error launching HyperVerge workflow:", error);
    throw error; // Re-throw so Kyc.jsx catch block can trigger manual fallback
  }
};


  
  